$("#btn-modal-promo-chat").on("click", function (e) {
  e.preventDefault();
  if (typeof Intercom == "function") {
    const code = $(this).data("code");
    Intercom("showNewMessage", code);
  }
});
